import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, CircularProgress } from '@mui/material';

// import CloseIcon from '@mui/icons-material';
// import instructionVideo from '../video/IRA_Video_20240819_121814_Meeting_Recording.mp4';


const VideoModal = ({ open, handleClose, videoUrl }) => {
  const [loading, setLoading] = useState(true);
  const handleIframeLoad = () => {
    setLoading(false);
  };
  return (
    <Dialog open={open} onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        style: {
          width: '90%',
          height: '90%',
          margin: '0',
          maxWidth: 'none',
          maxHeight: 'none',
        },
      }}>
      <DialogTitle>Instruction video</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        &#x2715;
      </IconButton>
      <DialogContent style={{
        padding: '20px 14px',
        paddingTop: "0px",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100% - 64px)',
        position: 'relative',
      }}>
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <CircularProgress />
          </div>
        )}
        <iframe id="video-iframe" width="100%" height="100%" src={videoUrl} title="System Price Calculator - Joe Heijda" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen onLoad={handleIframeLoad} style={{ borderRadius: '8px', display: loading ? 'none' : 'block' }}></iframe>
      </DialogContent>
    </Dialog>
  );
};


export default VideoModal;